export const IncomingApplicationReasonEnum = {
  'Student Not Found': 0,
  'Student Inactive': 1,
  'Student Mismatch': 2,
  Duplicate: 3,
  Homeless: 4,
  Migrant: 5,
  Runaway: 6,
  CaseNumber: 7,
};

export const CASE_NUMBER_REASON = 'Confirm Case#';



// WEBPACK FOOTER //
// ./src/pages/reviewincomingapplications/components/Constants.js